export type WorkingDay = {
  day: string;
  closed: boolean;
  open: string;
  close: string;
};

function parseTime(val?: string | null, defaultTime = "00:00"): Date {
  const safeValue =
    typeof val === "string" && /^\d{2}:\d{2}$/.test(val) ? val : defaultTime;

  const [hoursRaw, minutesRaw] = safeValue.split(":");

  let hours = Number(hoursRaw);
  let minutes = Number(minutesRaw);

  if (
    Number.isNaN(hours) ||
    Number.isNaN(minutes) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    hours = 0;
    minutes = 0;
  }

  return new Date(Date.UTC(1970, 0, 1, hours, minutes));
}

export function shiftTime(
  val?: string | null,
  offsetHours = 0,
  defaultTime = "00:00"
): string {
  const date = parseTime(val, defaultTime);

  const shiftedHours = (date.getUTCHours() + offsetHours + 24) % 24;
  const minutes = date.getUTCMinutes();

  return `${String(shiftedHours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export function formatOpeningHoursForDisplay(
  schedules: unknown
): string | null {
  if (!Array.isArray(schedules) || schedules.length === 0) {
    return null;
  }

  return formatWorkingHours(
    schedules.map(schedule => {
      const item = schedule as WorkingDay;

      return {
        ...item,
        open: shiftTime(item.open, 3),
        close: shiftTime(item.close, 3),
      };
    }),
    "\n"
  );
}

const dayShortMap: Record<string, string> = {
  sunday: "Sun",
  monday: "Mon",
  tuesday: "Tue",
  wednesday: "Wed",
  thursday: "Thu",
  friday: "Fri",
  saturday: "Sat",
};

export function formatWorkingHours(
  data: WorkingDay[],
  separator = ", "
): string {
  if (!data.length) return "-";

  return data
    .map(item => {
      const dayLabel = dayShortMap[item.day.toLowerCase()] || item.day;

      if (item.closed) {
        return `${dayLabel}: Closed`;
      }
      return `${dayLabel} ${item.open} - ${item.close}`;
    })
    .join(separator);
}
